export default __webpack_public_path__ + "static/media/bw_group_1432.89b852a8.svg";